import type { ReactElement } from 'react';

import { Background } from './brand-background.styled';

export const BrandBackground = (): ReactElement => (
  <Background role="presentation" />
);
